import { inject } from 'vue';
import mitt from 'mitt';
export const MittSymbol = Symbol();
export const MittService = {
    install: (app) => {
        app.provide(MittSymbol, mitt());
    },
};
export function useMitt() {
    const spinner = inject(MittSymbol);
    if (!spinner) {
        throw new Error(`Could not resolve ${MittSymbol.description}`);
    }
    return spinner;
}
